import { render, staticRenderFns } from "./add-prizes.vue?vue&type=template&id=b89d868c&"
import script from "./add-prizes.vue?vue&type=script&lang=js&"
export * from "./add-prizes.vue?vue&type=script&lang=js&"
import style0 from "./add-prizes.vue?vue&type=style&index=0&id=b89d868c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports